import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=44a822d1&scoped=true&lang=pug&"
import script from "./Filter.vue?vue&type=script&lang=js&"
export * from "./Filter.vue?vue&type=script&lang=js&"
import style0 from "./Filter.vue?vue&type=style&index=0&id=44a822d1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a822d1",
  null
  
)

/* custom blocks */
import block0 from "./Filter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports